import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
import { ModuleFE_FirebaseListener } from '@nu-art/firebase-frontend/ModuleFE_FirebaseListener/ModuleFE_FirebaseListener';
import { apiWithBody, apiWithQuery, ModuleFE_ServerInfo, ModuleFE_SyncManager, ModuleFE_Toaster, ModuleFE_XHR, StorageKey, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, _values, asArray, BadImplementationException, createLockedAsyncFunction, dbObjectToId, Debounce, exists, filterInstances, md5, MimeType_json, Module, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_SyncManager_CSV } from '@nu-art/thunderstorm-frontend/modules/sync-manager/ModuleFE_SyncManager_CSV';
import { ModuleFE_OpenTelemetry } from '@app/open-telemetry-frontend/ModuleFE_OpenTelemetry';
import { dispatch_NavModeUpdated } from './dispatchers.js';
import { ApiDef_Advisor, ApiDef_ArtifactSyncer, ApiDef_ProviderChat, avatarMode, EncounterStatus_Initial, EncounterStatus_Viewed, Key_StorageArtifactVersion, PathwayStatus, UrlParam_UserType, } from '@app/advisor-shared';
import { ModuleFE_EncounterMetadata } from '../../encounter-matadata/ModuleFE_EncounterMetadata.js';
import { ModuleFE_RuntimeSmartDoc } from '../runtime-smartDoc/ModuleFE_RuntimeSmartDoc.js';
import { ModuleFE_RuntimeOrder } from '../runtime-order/ModuleFE_RuntimeOrder.js';
import { ModuleFE_RuntimeFinding } from '../runtime-finding/ModuleFE_RuntimeFinding.js';
import { ModuleFE_InvalidRuntimeFinding } from '../runtime-finding/ModuleFE_InvalidRuntimeFinding.js';
import { ModuleFE_RuntimeProtocol } from '../runtime-protocol/ModuleFE_RuntimeProtocol.js';
import { ModuleFE_RuntimeActiveNavPathway, ModuleFE_RuntimeActiveNavState } from '../runtime-navigation-info/index.js';
import { dispatch_validateCache } from '../../../dispatchers.js';
import { ModuleFE_Advisor_Value } from '../../../modules/index.js';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
import { ModuleFE_ProviderChat } from '../provider-chat/ModuleFE_ProviderChat.js';
import { ModuleFE_ProviderChatInteraction } from '../provider-chat-interaction/ModuleFE_ProviderChatInteraction.js';
import { dispatch_OnPathwayEndUpdated } from '../../../ui/V4/dispatchers/general.js';
import { ModuleFE_SandboxOrders } from '../../../ui/sandbox/modules/ModuleFE_SandboxOrders/ModuleFE_SandboxOrders.js';
import { getAdvisorLogs } from '../../../logClients/LogClient_AdvisorMemBuffer.js';
// TBR - to be researched
export const StorageKey_SnapShotVersion = new StorageKey('advisor__snap-shot-version');
// Relevant to all encounters, not supposed to ever change once set. Is the same for a computer as a computer is correlated to one EHR instance any way, in one hospital.
// TBR - to be researched
export const StorageKey_ArtifactVersion = new StorageKey(Key_StorageArtifactVersion);
export const StorageKey_AvailableProtocols = new StorageKey('storage__available-protocols');
const dispatch_OnReadOnlyChanged = new ThunderDispatcher('__onReadOnlyChanged');
const dispatch_OnLoadingInitialData = new ThunderDispatcher('__onLoadingInitialData');
export const dispatch_OnAdvisorReset = new ThunderDispatcher('__onAdvisorReset');
const dispatch_OnBackgroundTasksChanged = new ThunderDispatcher('__onBackgroundTasksChanged');
// all negative values labels to filter in findings
const negativeValuesNames = ['none', 'no'];
export class ModuleFE_EMInterface_Class extends Module {
    vv1;
    userType;
    _readonly = false;
    _isLoadingInitialData = false;
    _hasBackgroundTasks = false;
    _backgroundTasksKnown = false;
    navMode = false;
    negativeValueIds = [];
    encounterTasksListener;
    ticketHashMap = {};
    // private consoleInterceptor;
    constructor() {
        super();
        this.vv1 = {
            advisorUtils: {
                updateEncounterStatus: apiWithBody(ApiDef_Advisor.vv1.advisorUtils.updateEncounterStatus),
                launchKickstart: apiWithBody(ApiDef_Advisor.vv1.advisorUtils.launchKickstart),
                resetAdvisorState: apiWithQuery(ApiDef_Advisor.vv1.advisorUtils.resetAdvisorState, this.onPostResetAdvisorState),
                submitSurvey: apiWithBody(ApiDef_Advisor.vv1.advisorUtils.submitSurvey),
                getEMQuaiEhrInstances: apiWithQuery(ApiDef_Advisor.vv1.advisorUtils.getEMQuaiEhrInstances),
                getEMQuaiEnvironments: apiWithQuery(ApiDef_Advisor.vv1.advisorUtils.getEMQuaiEnvironments),
                getEMQuaiFacilities: apiWithQuery(ApiDef_Advisor.vv1.advisorUtils.getEMQuaiFacilities),
                setPractitionerConfig: apiWithBody(ApiDef_Advisor.vv1.advisorUtils.setPractitionerConfig),
                recordPractitionerView: apiWithBody(ApiDef_Advisor.vv1.advisorUtils.recordPractitionerView),
            },
            protocols: {
                launchProtocol: apiWithQuery(ApiDef_Advisor.vv1.protocols.launchProtocol, res => this.handleEMResponse(res)),
                switchProtocolConsiderationGroup: apiWithQuery(ApiDef_Advisor.vv1.protocols.switchProtocolConsiderationGroup, async (res) => this.handleEMResponse(res)),
                getAvailableProtocols: apiWithQuery(ApiDef_Advisor.vv1.protocols.getAvailableProtocols, this.handleAvailableProtocolsRequest),
            },
            orders: {
                resolveOrder: apiWithBody(ApiDef_Advisor.vv1.orders.resolveOrder, async (res) => {
                    await this.handleEMResponse(res);
                }),
                completeOrders: apiWithBody(ApiDef_Advisor.vv1.orders.completeOrders, (res) => ModuleFE_RuntimeOrder.onEntriesUpdated(res.runtimeOrders)),
                createRunTimeOrders: apiWithBody(ApiDef_Advisor.vv1.orders.createRunTimeOrders),
                acceptRuntimeOrders: apiWithBody(ApiDef_Advisor.vv1.orders.acceptRuntimeOrders),
                rejectRuntimeOrders: apiWithBody(ApiDef_Advisor.vv1.orders.rejectRuntimeOrders),
            },
            navigator: {
                manualNavigateOnTransition: apiWithBody(ApiDef_Advisor.vv1.navigator.manualNavigateOnTransition, async (res) => this.handleEMResponse(res)),
                goToState: apiWithBody(ApiDef_Advisor.vv1.navigator.goToState, (res) => this.handleEMResponse(res)),
                simulateNavigation: apiWithBody(ApiDef_Advisor.vv1.navigator.simulateNavigation),
            },
            calculator: {
                getExpressionNeededVariables: apiWithBody(ApiDef_Advisor.vv1.calculator.getExpressionNeededVariables),
                simulateExpressionCalculation: apiWithBody(ApiDef_Advisor.vv1.calculator.simulateExpressionCalculation),
            },
            encounter: {
                clearEncounterState: apiWithQuery(ApiDef_Advisor.vv1.encounter.clearEncounterState),
                endEncounter: apiWithBody(ApiDef_Advisor.vv1.encounter.endEncounter, async (res, request) => {
                    await this.handleEMResponse(res);
                }),
                updateEncounter: apiWithBody(ApiDef_Advisor.vv1.encounter.updateEncounter, (res) => this.handleEMResponse(res)),
                updatePertinentSummary: apiWithQuery(ApiDef_Advisor.vv1.encounter.updatePertinentSummary),
            },
            sandbox: {
                getNlpSandboxVariables: apiWithBody(ApiDef_Advisor.vv1.sandbox.getNlpSandboxVariables),
                getFHIRQuerySandbox: apiWithBody(ApiDef_Advisor.vv1.sandbox.getFHIRQuerySandbox),
                fhirSandbox: apiWithBody(ApiDef_Advisor.vv1.sandbox.fhirSandbox),
            },
            debug: {
                getFindingsDump: apiWithQuery(ApiDef_Advisor.vv1.debug.getFindingsDump),
                getEncounterDataExport: apiWithQuery(ApiDef_Advisor.vv1.debug.getEncounterDataExport),
                submitSupportTicket: apiWithBody(ApiDef_Advisor.vv1.debug.submitSupportTicket),
                isEMAlive: apiWithQuery(ApiDef_Advisor.vv1.debug.isEMAlive)
            },
            smartNote: {
                get: apiWithBody(ApiDef_Advisor.vv1.smartNote.get),
                save: apiWithBody(ApiDef_Advisor.vv1.smartNote.save),
                writeBack: apiWithBody(ApiDef_Advisor.vv1.smartNote.writeBack, this.onSmartNoteWriteBack),
            },
            smartLog: {
                createProvidersNote: apiWithBody(ApiDef_Advisor.vv1.smartLog.createProvidersNote, response => ModuleFE_RuntimeSmartDoc.onEntriesUpdated([response.smartLog])),
                updateProvidersNote: apiWithBody(ApiDef_Advisor.vv1.smartLog.updateProvidersNote, (res) => this.handleEMResponse(res))
            },
            smartOnFHIR: {
                smartOnFhir: apiWithQuery(ApiDef_Advisor.vv1.smartOnFHIR.smartOnFhir),
                getSandboxLaunchUrl: apiWithBody(ApiDef_Advisor.vv1.smartOnFHIR.getSandboxLaunchUrl),
                temp_deployIntegration: apiWithBody(ApiDef_Advisor.vv1.smartOnFHIR.temp_deployIntegration),
            },
            chatting: {
                sendPrompt: apiWithBody(ApiDef_ProviderChat.sendPrompt, this.onSendPrompt),
            },
            launch: {
                bootstrap: apiWithQuery(ApiDef_Advisor.vv1.launch.bootstrap),
            }
        };
    }
    init() {
        super.init();
        ModuleFE_OpenTelemetry.initializeOTel('FE-Advisor');
    }
    /**
     * Submits a support ticket, automatically attaching the non-contextual data - the
     * sandbox/AGL message history and the recent in-memory app logs.
     *
     * Callers only need to provide the (contextual) ticket itself.
     */
    submitSupportTicket = async (ticket) => {
        const hash = md5(__stringify(ticket));
        if (exists(this.ticketHashMap[hash]))
            return;
        try {
            //Add ticket hash before sending to prevent dupes while waiting for a response
            this.ticketHashMap[hash] = Date.now();
            await this.vv1.debug.submitSupportTicket({
                ticket,
                aglHistory: ModuleFE_SandboxOrders.getHistory(),
                logs: getAdvisorLogs(),
            }).executeSync();
        }
        catch (err) {
            //Clear hash on error to allow re-sending
            delete this.ticketHashMap[hash];
            return err;
        }
    };
    __onEncounterMetadataUpdated(...params) {
        if (!['update', 'create', 'unique', 'upsert-all'].includes(params[0]))
            return;
        // not post disposition
        if (!asArray(params[1])[0]?.dispositionData)
            return;
        // update app that dispo occured
        dispatch_OnPathwayEndUpdated.dispatchAll();
    }
    startFirebaseListeners = () => {
        ModuleFE_SyncManager.startListening();
        ModuleFE_ServerInfo.startListening();
        this.startEncounterTasksListener();
    };
    stopFirebaseListeners = () => {
        ModuleFE_ServerInfo.stopListening();
        ModuleFE_SyncManager.stopListening();
        ModuleFE_SyncManager.cancelSync();
        this.stopEncounterTasksListener();
    };
    startEncounterTasksListener = () => {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        if (!encounterId)
            return;
        const nodePath = `/state/DataSyncManager/${encounterId}/encounterBackgroundTasks`;
        this.encounterTasksListener = ModuleFE_FirebaseListener
            .createListener(nodePath)
            .startListening(snapshot => {
            const tasks = snapshot.val();
            if (!Array.isArray(tasks)) {
                // Firebase RTDB stores [] as null. Ignore the first missing node;
                // after we have seen a real list, null means tasks finished.
                if (this._backgroundTasksKnown)
                    this.setHasBackgroundTasks(false);
                return;
            }
            const hasTasks = tasks.length > 0;
            const wasKnown = this._backgroundTasksKnown;
            this._backgroundTasksKnown = true;
            this.setHasBackgroundTasks(hasTasks, !wasKnown && !hasTasks);
        });
    };
    stopEncounterTasksListener = () => {
        this.encounterTasksListener?.stopListening();
        this.encounterTasksListener = undefined;
        this._backgroundTasksKnown = false;
        this._hasBackgroundTasks = false;
    };
    /**
     * Get available protocols api callback, will set the available protocols storage key in order to
     * make sure that it always have up to date data
     * @param response - the current available protocols of the encounter
     */
    handleAvailableProtocolsRequest = async (response) => {
        StorageKey_AvailableProtocols.set(response);
    };
    /**
     * General function that handles EM response
     * @param res The default em response got from the encounter manager
     * @param updateIDBTimestamp
     */
    handleEMResponse = async (res, updateIDBTimestamp = true) => {
        if (res.findings) {
            await Promise.all([
                ModuleFE_RuntimeFinding.onEntriesUpdated(res.findings.updated, updateIDBTimestamp),
                ModuleFE_RuntimeFinding.onEntriesDeleted(res.findings.deleted),
                ModuleFE_InvalidRuntimeFinding.onEntriesUpdated(res.findings.deleted, updateIDBTimestamp)
            ]);
        }
        if (res.protocols)
            await ModuleFE_RuntimeProtocol.onEntriesUpdated(res.protocols, updateIDBTimestamp);
        if (res.runtimeOrder) {
            await ModuleFE_RuntimeOrder.onEntriesDeleted(res.runtimeOrder.deletedRuntimeOrders ?? []);
            await ModuleFE_RuntimeOrder.onEntriesUpdated(res.runtimeOrder.updatedRuntimeOrders ?? [], updateIDBTimestamp);
        }
        if (res.smartLogs)
            await ModuleFE_RuntimeSmartDoc.onEntriesUpdated(res.smartLogs, updateIDBTimestamp);
        if (res.encounterMetadata)
            await ModuleFE_EncounterMetadata.onEntriesUpdated([res.encounterMetadata], updateIDBTimestamp);
        if (res.activeStates)
            await ModuleFE_RuntimeActiveNavState.onEntriesUpdated(res.activeStates, updateIDBTimestamp);
        if (res.activePathways)
            await ModuleFE_RuntimeActiveNavPathway.onEntriesUpdated(res.activePathways, updateIDBTimestamp);
        // validate cache - async, shouldn't be awaited
        dispatch_validateCache.dispatchAllAsync();
    };
    // TODO: use ModuleFE_Provider instead
    resolveUserType = () => {
        if (!this.userType) {
            const path = window.location.pathname;
            const urlParams = new URLSearchParams(window.location.search);
            const userTypeFromParams = urlParams.get(UrlParam_UserType);
            if (path.includes('/launch-avatar'))
                this.userType = avatarMode;
            //Ignore if not in advisor
            else if (!path.includes('/advisor') || path.includes('/advisor-wrapper'))
                return;
            else if (path.includes('/nurse'))
                this.userType = 'nurse';
            else if (path.includes('/physician'))
                this.userType = userTypeFromParams === avatarMode ? 'avatar-mode' : 'physician';
            else if (path.includes('/sandbox-orders'))
                this.userType = 'sandbox-orders';
            else if (path.includes('/sandbox-nlp'))
                this.userType = 'sandbox-nlp';
            else if (path.includes('/sandbox-FHIR-query'))
                this.userType = 'sandbox-FHIR-query';
            else {
                throw new BadImplementationException(`Could not get user type from url ${path}`);
            }
        }
        return this.userType;
    };
    // TODO: use ModuleFE_Provider instead
    getUserType = () => {
        if (!this.userType)
            this.userType = this.resolveUserType();
        return this.userType;
    };
    collectedNegativeValueIds = () => {
        this.negativeValueIds = ModuleFE_Advisor_Value.cache
            .filter(value => value.type === 'enum-element'
            && negativeValuesNames.includes(value.data.value.toLowerCase())).map(dbObjectToId);
    };
    isNegativeValue = (valueId) => {
        if (!this.negativeValueIds.length)
            this.collectedNegativeValueIds();
        return this.negativeValueIds.includes(valueId);
    };
    isAvatarMode = () => ModuleFE_AdvisorSession.getIsAvatar();
    canCreateBugReport = () => {
        const provider = ModuleFE_AdvisorSession.getSessionProvider().display_name;
        return provider !== 'Simulation Mode';
    };
    shouldTriggerDowntimePage = () => {
        return this.config.triggerDowntimePage;
    };
    setReadOnly = (readOnly) => {
        if (this._readonly === readOnly)
            return;
        this._readonly = readOnly;
        dispatch_OnReadOnlyChanged.dispatchAll();
    };
    setLoadingInitialData = (value) => {
        this._isLoadingInitialData = value;
        dispatch_OnLoadingInitialData.dispatchAll();
    };
    isLoadingInitialData = () => this._isLoadingInitialData;
    isPatientDataLoading = () => this._readonly;
    isReadonly = () => this.isAvatarMode() || this._readonly;
    setHasBackgroundTasks = (value, forceDispatch = false) => {
        if (this._hasBackgroundTasks === value && !forceDispatch)
            return;
        this._hasBackgroundTasks = value;
        dispatch_OnBackgroundTasksChanged.dispatchAll();
    };
    hasBackgroundTasks = () => this._hasBackgroundTasks;
    isPostDisposition = () => {
        // Check if the metadata for this encounter has disposition data on it
        return !!ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData;
    };
    isNavMode = () => this.navMode;
    setNavMode = (navMode) => {
        if (navMode === this.navMode)
            return;
        this.navMode = navMode;
        dispatch_NavModeUpdated.dispatchAll();
    };
    getEndedProtocol = () => {
        const relevantStatuses = [PathwayStatus.ADMIT_COMPLETED, PathwayStatus.DISCHARGE_COMPLETED];
        return ModuleFE_RuntimeProtocol.getAllProtocols().find(protocol => relevantStatuses.includes(protocol.status));
    };
    typescriptSync = async (artifactData) => {
        const path = this.config.artifactLoaderEndpoint + `${ApiDef_ArtifactSyncer.getArtifact.path}`;
        await ModuleFE_SyncManager_CSV.syncFromCSVUrl(path, {
            downloadRequestHeaders: {
                ...ModuleFE_XHR.getDefaultHeaders(),
                [HeaderKey_ContentType]: MimeType_json,
            },
            downloadRequestBody: JSON.stringify({ pathToFile: artifactData.advisorArtifactSignedUrl }),
        });
    };
    syncSnapShot = async () => {
        try {
            const currentVersion = StorageKey_SnapShotVersion.get();
            const artifactData = ModuleFE_AdvisorSession.getSessionLaunchData();
            if (!artifactData.dataVersion || !artifactData.advisorArtifactSignedUrl)
                throw new MUSTNeverHappenException('cannot sync artifact without necessary data');
            StorageKey_ArtifactVersion.set(artifactData.dataVersion);
            if (artifactData.dataVersion === currentVersion) {
                this.logInfo(`Same version(${currentVersion}), no need to sync`);
                return ModuleFE_SyncManager_CSV.readyAllModules();
            }
            this.logInfo(`syncing snapshot version(${currentVersion})`);
            const urlsGroup = this.resolveArtifactUrls(artifactData);
            for (const group of urlsGroup) {
                this.logInfo('syncing CSVs in group', group);
                await Promise.all(group.map(url => this.typescriptSync({ ...artifactData, advisorArtifactSignedUrl: url })))
                    .then(() => this.logInfo(`successfully synced ${group.length} csv(s)`))
                    .catch(err => this.logError('Failed to sync some CSVs', err));
            }
            //Ready all modules that weren't initialized by sync
            await ModuleFE_SyncManager_CSV.readyAllUnreadyModules();
            StorageKey_SnapShotVersion.set(artifactData.dataVersion);
        }
        catch (err) {
            this.logError('error syncing csv', err);
        }
    };
    resolveArtifactUrls = (artifactData) => {
        if (!artifactData.advisorArtifactSignedUrls)
            return [[artifactData.advisorArtifactSignedUrl]];
        const toRet = [];
        _values(artifactData.advisorArtifactSignedUrls).forEach(item => {
            if (!toRet[item.priority])
                toRet[item.priority] = [];
            toRet[item.priority].push(item.signedUrl);
        });
        return filterInstances(toRet);
    };
    onPostResetAdvisorState = async (emResponse) => {
        try {
            if (emResponse.artifactMetadata) // ← new field
                ModuleFE_AdvisorSession.setArtifactMetadata(emResponse.artifactMetadata);
            StorageKey_SnapShotVersion.delete();
            StorageKey_AvailableProtocols.delete();
            dispatch_OnAdvisorReset.dispatchAll();
            this.logWarning('onPostResetAdvisorState - syncSnapShot');
            await this.syncSnapShot();
        }
        catch (err) {
            ModuleFE_Toaster.toastError('Error while connecting server, please try again in few moments...');
        }
    };
    //########################## Update encounter ##########################
    updateEncounterApis = {
        updateNeededVariables: (findings) => {
            return this.updateEncounter({ ...findings.findings });
        },
        updatedNeededVariablesWithSuggestions: (findings, suggestions) => {
            return this.updateEncounter({
                findingsToUpdate: findings.findingsToUpdate,
                processedRawFindings: findings.processedRawFindings,
                approvedSuggestions: suggestions.accepted,
                rejectedSuggestions: suggestions.rejected,
            });
        },
        updateRequiredSnippets: async (updateSnippetsRequest) => {
            return this.updateEncounter({
                patientDataSnippets: updateSnippetsRequest.patientDataSnippets,
                processedRawFindings: updateSnippetsRequest.processedRawFindings,
                findingsToUpdate: updateSnippetsRequest.findingsToUpdate,
                runtimeOrderId: updateSnippetsRequest.rtOrderId,
            }, { fulfilledWizards: updateSnippetsRequest.fulfilledSnippetId });
        },
        submitWizardStep: async (request) => {
            //Send Data To EM - Call this.updateRequiredSnippets
            const _request = {
                patientDataSnippets: request.patientDataSnippets,
                processedRawFindings: request.processedRawFindings,
                findingsToUpdate: request.findingsToUpdate,
                rtOrderId: request.runtimeOrderId,
                fulfilledSnippetId: request.fulfilled ? [request.wizardId] : undefined,
            };
            // resolve the order when wizard is fulfilled
            let resolvedOrders;
            if (request.fulfilled && request.runtimeOrderId)
                resolvedOrders = (await this.vv1.orders.resolveOrder({
                    fulfilledWizards: [request.wizardId],
                    runtimeOrderId: request.runtimeOrderId,
                    patientData: {}
                }).executeSync()).runtimeOrder;
            // update the final step results with resolved order data
            const resolvedStepData = await this.updateEncounterApis.updateRequiredSnippets(_request);
            resolvedStepData.runtimeOrder = resolvedOrders;
            return resolvedStepData;
        },
        refreshFhirData: () => {
            return this.updateEncounter(undefined, {
                refreshFhirDataRequest: {
                    refreshOrder: true,
                    snippetsIds: this.config.generalFhirRefreshSnippetIds ?? [],
                    fhirQueriesIds: this.config.generalFhirQueriesIds ?? []
                }
            });
        },
        refreshHPI: () => {
            return this.updateEncounter(undefined, {
                refreshFhirDataRequest: {
                    refreshOrder: false,
                    fhirQueriesIds: this.config.hpiFhirQueriesIds ?? [],
                    snippetsIds: this.config.hpiFhirRefreshSnippetIds ?? []
                }
            });
        }
    };
    updateEncounter = async (patientData, extraParams) => {
        return this.vv1.encounter.updateEncounter({ patientData, ...extraParams }).executeSync();
    };
    promoteEncounterToViewed = createLockedAsyncFunction(async () => {
        const status = ModuleFE_EncounterMetadata.getEncounterMetadata()?.encounterStatus;
        if (status !== EncounterStatus_Initial)
            return;
        if (ModuleFE_EMInterface.isAvatarMode())
            return;
        try {
            await ModuleFE_EMInterface.vv1.advisorUtils.updateEncounterStatus({ status: EncounterStatus_Viewed }).executeSync();
        }
        catch (err) {
            ModuleFE_EMInterface.logError(err);
        }
    });
    debounce_RecordPractitionerView = new Debounce(async () => {
        try {
            await this.vv1.advisorUtils.recordPractitionerView().executeSync();
            ModuleFE_AdvisorSession.updateCurrentLastSeen();
            this.logDebug('Recorded practitioner "view"');
        }
        catch (e) {
            this.logError('Could not record practitioner "view"', e);
        }
    }, 200, 500);
    recordPractitionerView = () => this.debounce_RecordPractitionerView.trigger();
    //########################## Smart Note ##########################
    getSmartNoteStorageKey = (templateId) => {
        const key = `smart-note.${templateId}.${ModuleFE_AdvisorSession.getCurrentEncounterId()}`;
        return new StorageKey(key);
    };
    onSmartNoteWriteBack = async (response, body) => {
        const _body = JSON.parse(body);
        const templateId = _body.note.templateId;
        const key = this.getSmartNoteStorageKey(templateId);
        key.set(_body.note);
        this.logInfo(key.key, key.get());
    };
    //########################## Chatting ##########################
    onSendPrompt = async (response) => {
        await ModuleFE_ProviderChat.onEntriesUpdated([response.chat]);
        await ModuleFE_ProviderChatInteraction.onEntriesUpdated([response.interaction]);
    };
}
export const ModuleFE_EMInterface = new ModuleFE_EMInterface_Class();
//# sourceMappingURL=ModuleFE_EMInterface.js.map